import { Check } from "lucide-react";

interface StepperProps {
  steps: string[];
  current: number; // 0-based
}

/** Horizontal step header for multi-step wizards (Promotion wizard, PR-1). */
export function Stepper({ steps, current }: StepperProps) {
  return (
    <ol className="flex items-center gap-2 overflow-x-auto pb-1" aria-label="Steps">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={label} className="flex shrink-0 items-center gap-2">
            <span
              className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium ${
                done
                  ? "bg-action-primary text-primary-foreground"
                  : active
                    ? "border-2 border-action-primary text-action-primary"
                    : "border border-border text-muted-foreground"
              }`}
              aria-current={active ? "step" : undefined}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <span className={`text-sm whitespace-nowrap ${active ? "font-medium text-foreground" : "text-muted-foreground"}`}>
              {label}
            </span>
            {i < steps.length - 1 && <span className="mx-1 h-px w-6 bg-border" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}
